import type { SavasOlayi } from '@kurultay/savas'

export interface OynatimAdimi {
  olay: SavasOlayi
  gecikmeMs: number
}

/** Olay türüne göre temel gecikme. Hızlandırma bunları böler. */
const GECIKME: Record<SavasOlayi['tip'], number> = {
  savas_basladi: 400,
  tur_basladi: 400,
  durus_degisti: 450,
  saldiri: 500,
  ofke_degisti: 0,   // anında, kesinti yaratmasın
  olum: 600,
  savas_bitti: 800,
}

/**
 * Olay listesini animasyon adımlarına çevirir.
 * hiz ∈ {1, 2, 4} — gecikmeleri böler.
 */
export function adimlariUret(olaylar: SavasOlayi[], hiz: number): OynatimAdimi[] {
  const bolen = Math.max(1, hiz)
  return olaylar.map((olay) => ({ olay, gecikmeMs: GECIKME[olay.tip] / bolen }))
}

/** Bir olay dizisinin toplam oynatım süresi. */
export function toplamSure(adimlar: OynatimAdimi[]): number {
  return adimlar.reduce((t, a) => t + a.gecikmeMs, 0)
}
